import {
    SET_USERS,
    SET_USER_BRANCHES,
    SAVE_USER_BRANCH_SUCCESS,
    SET_USER_PROFILE_IMAGE
} from './UserProfileTypes';


const reducers = (state = [], action: any) => {
    switch (action.type) {
        case SET_USERS:
            return {
                ...state,
                users: action.users,
            };
        case SET_USER_BRANCHES:
            return {
                ...state,
                branches: action.branches,
            };
        case SAVE_USER_BRANCH_SUCCESS:
            return {
                ...state,
                branchesSaved: action.flag,
            };
        case SET_USER_PROFILE_IMAGE:
            return {
                ...state,
                userProfileImage: action.response,
            };
        default:
            return state;
    }
}

export default reducers